import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Footer() {
  const canSeePassport = localStorage.getItem('canSeePassport') === 'true';
  const passportTypes = JSON.parse(localStorage.getItem('passportTypes') || '[]');

  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    // Update the current year when the component mounts
    setCurrentYear(new Date().getFullYear());
  }, []);

  useEffect(() => {
  }, [canSeePassport, passportTypes]);

  return (
    <div aria-label="Site Footer" className="bg-gray-900">
      <div className="max-w-screen-xl px-4 py-16 mx-auto sm:px-6 lg:px-8">
        <div className="lg:flex lg:gap-8">
          <div className="grid grid-cols-2 gap-8 mt-8 lg:mt-0 lg:grid-cols-6 lg:gap-y-16">

            <div className="col-span-2 pt-6 border-t border-white/10 sm:col-span-1">
              <p className="font-bold text-white">About us</p>

              <nav
                aria-label="Footer Nav"
                className="flex flex-col mt-6 space-y-4 text-sm text-gray-300"
              >
                <a
                  className="inline-block"
                  href="https://combanketh.et/en/about"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CBE Profile 
                </a>

                <Link className="inline-block" to="/BoardofDirectors">
                  {" "}
                  Board of Directors{" "}
                </Link>
                <Link className="inline-block" to="/executiveManagement">
                  {" "}
                  Executive Management{" "}
                </Link>
                <a
                  className="inline-block"
                  href="https://combanketh.et/en/organizational-structure"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                     Organizational Structure
                </a>
              </nav>
            </div>
            <div className="col-span-2 pt-6 border-t border-white/10 sm:col-span-1">
              <p className="font-bold text-white">CONTACT US</p>

              <nav className="flex flex-col mt-6 space-y-4 text-sm text-gray-300">
                <Link className="inline-block" to="#">
                  {" "}
                  Email info@cbe.com.et
                </Link>
                <Link className="inline-block" to="#">
                  {" "}
                  Phone 251-551-50-04
                </Link>
                <Link className="inline-block" to="#">
                  {" "}
                  Ras Desta Damtew St, 01, Kirkos, Addis Ababa, Ethiopia.
                </Link>
              </nav>
            </div>


            <div className="col-span-2 pt-6 border-t border-white/10 sm:col-span-1">
              <p className="font-bold text-white">SUPPORT</p>

              <nav className="flex flex-col mt-6 space-y-4 text-sm text-gray-300">
                <Link className="inline-block" to="#">
                  {" "}
                  Call 951{" "}
                </Link>
                <Link className="inline-block" to="/faq">
                  {" "}
                  Faq{" "}
                </Link>
              </nav>
            </div>
            <div className="col-span-2 pt-6 border-t border-white/10 sm:col-span-1">
              <p className="font-bold text-white">Passports</p>
              <nav className="flex flex-col mt-6 space-y-4 text-sm text-gray-300">
                {canSeePassport && passportTypes.map((type) => {
                  return (type.role === "BOD" || type.role === "EMC") &&
                    <Link key={type.id} className="inline-block" to={`/${type.role}Passport`}>{type.role} Passport</Link>;
                })}
              </nav>
            </div>
            <div className="col-span-2 pt-6 border-t border-white/10 sm:col-span-1">
              <p className="font-bold text-white">List of BODs and EMCs</p>

              <nav className="flex flex-col mt-6 space-y-4 text-sm text-gray-300">
                <Link className="inline-block" to="/bodLists">
                  {" "}
                  LIST OF Board of Directors{" "}
                </Link>
                <Link className="inline-block" to="/emcLists">
                  {" "}
                  LIST OF EMC{" "}
                </Link>
              </nav>
            </div>
          </div>
        </div>

        <div className="pt-8 mt-12 border-t border-white/10">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            <p className="text-xs text-center text-gray-400 lg:text-left">
            © {currentYear} Comercial Bank of Ethiopia. All rights reserved.
            </p>

            <div className="flex justify-center gap-4 text-xs text-gray-400 lg:justify-end">
              {/* Footer Links */}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Footer;
